module.exports = __webpack_public_path__ + "img/gzhj_03.ae1da7ef.jpg";